import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"pa-2",attrs:{"fluid":""}},[_c(VRow,[_c(VCol,[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.noRights'))}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }